import classNames from 'clsx'
import { bool, shape, string } from 'prop-types'
import { Fragment } from 'react'

import { omit } from 'shared/utils/objectUtils'
import { getAbsoluteUrl } from 'shared/utils/url'
import Input from 'views/components/atoms/Input'
import ProductVariantCompactDetails from 'views/components/organisms/ProductVariantsCompact/ProductVariantCompact/ProductVariantCompactDetails'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { isProductAvailable } from 'views/utils/productUtils'
import {
  ProductVariantType,
  publicRuntimeConfigType,
} from 'views/utils/propTypes'
import { isRequired } from 'views/utils/propTypeUtils'

import 'views/components/organisms/ProductVariants/ProductVariant/ProductVariant.scss'

const ProductVariantCompact = ({
  checked,
  radioButton,
  groupName,
  variant,
  alwaysClickable,
  publicRuntimeConfig: {
    publicConfig: { shopURL },
  },
}) => {
  const isNotAvailable = !isProductAvailable(variant.stockStatus)
  const labelClassName = classNames(
    'l-flex l-flex--distribute-space m-ProductVariant__label u-border-radius',
    {
      'm-ProductVariant__label--checked': checked,
    }
  )
  const containerClassName = classNames(
    'm-ProductVariant m-ProductVariant--compact',
    {
      'm-ProductVariant--disabled': isNotAvailable,
    }
  )

  const isNotLink = checked || (!alwaysClickable && isNotAvailable)
  const VariantWrapper = isNotLink ? Fragment : 'a'
  const variantProps = {}

  if (!isNotLink) {
    variantProps.className = 'a-link a-link--neutral m-ProductVariant__link'
    variantProps.href = getAbsoluteUrl(shopURL, variant.canonicalURL)
    variantProps['data-clientside-hook'] = 'productVariantButton'
  }

  return radioButton ? (
    <div className={containerClassName}>
      <div className="m-ProductVariant__link">
        <Input
          type="radio"
          value={variant.id}
          id={variant.id}
          name={groupName}
          className="m-ProductVariant__input u-hidden"
          defaultChecked={checked}
        />
        <label htmlFor={variant.id} className={labelClassName}>
          <ProductVariantCompactDetails
            variant={variant}
            isNotAvailable={isNotAvailable}
          />
        </label>
      </div>
    </div>
  ) : (
    <div className={containerClassName}>
      <VariantWrapper {...variantProps}>
        <div className={labelClassName}>
          <ProductVariantCompactDetails
            variant={variant}
            isNotAvailable={isNotAvailable}
          />
        </div>
      </VariantWrapper>
    </div>
  )
}

ProductVariantCompact.propTypes = {
  variant: shape(isRequired(omit(ProductVariantType, ['followUpProductCode'])))
    .isRequired,
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
  checked: bool,
  radioButton: bool,
  groupName: string,
  alwaysClickable: bool,
}

ProductVariantCompact.defaultProps = {
  checked: false,
  radioButton: false,
  groupName: 'packageVariant',
  alwaysClickable: false,
}

export default withShopAndRuntimeConfig(ProductVariantCompact)
